window.Products.Clothing.LooseTankTop = function() {
};
window.Products.Clothing.LooseTankTop.inherits(window.Products.Clothing.Clothing);

window.Products.Clothing.LooseTankTop.id = 64;
window.Products.Clothing.LooseTankTop.slug = 'loose-tank-top';
window.Products.Clothing.LooseTankTop.has_3d = true;
window.Products.Clothing.LooseTankTop.has_subproducts = true;
window.Products.Clothing.LooseTankTop.dpi = 150;
window.Products.Clothing.LooseTankTop.camera_fixed = -1.6;

window.Products.Clothing.LooseTankTop.prototype.set3dProperties = function(modelViewer) {
    modelViewer.object.position.y = 0.02;
    this.updateThreeTexture(modelViewer);
    modelViewer.initalCameraPosition.z = this.parent.static.camera_fixed;
    if(!modelViewer.inlab){
        modelViewer.setFixedView('front');
        modelViewer.enableAutoRotate(0.5);
        modelViewer.camera.position.z = 0.5;
    }
};

window.Products.Clothing.LooseTankTop.prototype.setSide = function(option, modelViewer) {
    var me = this;
    
    // Reset
    modelViewer.object.children[0].material.color = {r: 0.2, g: 0.2, b: 0.2};
    modelViewer.object.children[1].material.color = {r: 0.2, g: 0.2, b: 0.2};
    modelViewer.object.children[2].material.color = {r: 0.7450980392156863, g: 0.7450980392156863, b: 0.7450980392156863};
    modelViewer.object.children[3].material.color = {r: 0.7450980392156863, g: 0.7450980392156863, b: 0.7450980392156863};

    modelViewer.object.children[0].material.emissive = {r:0.6901960784313725, g:0.6901960784313725, b:0.6901960784313725};
    modelViewer.object.children[1].material.emissive = {r:0.6901960784313725, g:0.6901960784313725, b:0.6901960784313725};

    modelViewer.object.children[0].material.map = modelViewer.texture;
    modelViewer.object.children[1].material.map = modelViewer.texture;
    modelViewer.object.children[2].material.map = modelViewer.texture;
    modelViewer.object.children[3].material.map = modelViewer.texture;

    if(option == 'double-sided') return;

    var side = option.split('-')[0];
    var color = option.split('-').slice(1).join('-');

    var newcolor;
    switch(color){
        case 'black':
            newcolor = {r:0.1, g:0.1, b:0.1};
            break;
        case 'white':
            newcolor = {r:220/255, g:220/255, b:220/255};
            break;
        case 'electric-blue':
            newcolor = {r:8/255, g:130/255, b:160/255};
            break;
        case 'pink':
            newcolor = {r:0.68, g:0.21, b:0.52};
            break;
        case 'cherry':
            newcolor = {r:60/255, g:5/255, b:10/255};
            break;
        case 'gray' : 
            newcolor = {r:0.3, g:0.3, b:0.3};
            break;
    }

    switch(side){
        case 'front':
            modelViewer.object.children[1].material.color = newcolor;
            modelViewer.object.children[3].material.color = newcolor;
            modelViewer.object.children[1].material.emissive = {r:0, g:0, b:0};
            modelViewer.object.children[1].material.map = modelViewer.object.children[0].material.bumpMap;
            modelViewer.object.children[3].material.map = modelViewer.object.children[0].material.bumpMap;
            break;
        case 'back':
            modelViewer.object.children[0].material.color = newcolor;
            modelViewer.object.children[2].material.color = newcolor;
            modelViewer.object.children[0].material.emissive = {r:0, g:0, b:0};
            modelViewer.object.children[0].material.map = modelViewer.object.children[0].material.bumpMap;
            modelViewer.object.children[2].material.map = modelViewer.object.children[0].material.bumpMap;
            break;
    }


    modelViewer.object.children[0].material.needsUpdate = true;
    modelViewer.object.children[1].material.needsUpdate = true;
    modelViewer.object.children[2].material.needsUpdate = true;
    modelViewer.object.children[3].material.needsUpdate = true;
};

window.Products.Clothing.LooseTankTop.prototype.setThreeControls = function(controls) {
    controls.minDistance = 1.7;
    controls.maxDistance = 2.1;
};

window.Products.Clothing.LooseTankTop.prototype.updateThreeTexture = function(modelViewer) {
    modelViewer.object.children[0].material.map = modelViewer.texture;
    modelViewer.object.children[1].material.map = modelViewer.texture;
    modelViewer.object.children[2].material.map = modelViewer.texture;
    modelViewer.object.children[3].material.map = modelViewer.texture;
    modelViewer.object.children[0].material.bumpScale = 0.0005;
    modelViewer.object.children[1].material.bumpScale = 0.0005;
    modelViewer.object.children[2].material.bumpScale = 0.0005;
    modelViewer.object.children[3].material.bumpScale = 0.0005;
    modelViewer.object.children[0].material.bumpMap.wrapS = THREE.RepeatWrapping;
    modelViewer.object.children[1].material.bumpMap.wrapS = THREE.RepeatWrapping;
    modelViewer.object.children[2].material.bumpMap.wrapS = THREE.RepeatWrapping;
    modelViewer.object.children[3].material.bumpMap.wrapS = THREE.RepeatWrapping;
    modelViewer.object.children[0].material.bumpMap.wrapT = THREE.RepeatWrapping;
    modelViewer.object.children[1].material.bumpMap.wrapT = THREE.RepeatWrapping;
    modelViewer.object.children[2].material.bumpMap.wrapT = THREE.RepeatWrapping;
    modelViewer.object.children[3].material.bumpMap.wrapT = THREE.RepeatWrapping;
    modelViewer.object.children[0].material.bumpMap.repeat.set(5,5);
    modelViewer.object.children[1].material.bumpMap.repeat.set(5,5);
    modelViewer.object.children[2].material.bumpMap.repeat.set(5,5);
    modelViewer.object.children[3].material.bumpMap.repeat.set(5,5);
};